<template>
  <div class="gs-preview-overlay sdm-overlay" @click.stop="close">
    <div class="sdm-modal" @click.stop>
      <div  v-if="!isCountingDown" class="sdm-header">
        <h2  class="sdm-title">{{ titleText }}</h2>
        <i class="el-icon-close sdm-close" @click="close"></i>
      </div>
      
      <template v-if="!isCountingDown">
        <p class="sdm-subtitle">{{ subtitleText }}</p>
        
        <div class="sdm-preview-area">
        <template v-if="cpaStat">
          <div class="sdm-bloom-info">
            <h3 class="sdm-bloom-level">Level {{ cpaStat.levelNum }}: {{ cpaStat.levelNameFormated }}</h3>
            <div class="sdm-bloom-stats">
              <span class="sdm-stat-attempted">{{ cpaStat.attempt }} Attempted</span>
              <span class="sdm-stat-stuck">{{ cpaStat.correct }} Stuck</span>
              <span class="sdm-stat-wrong">{{ cpaStat.wrong }} Wrong</span>
            </div>
          </div>
          <div class="sdm-cpa-box">
            <div class="sdm-cpa-question" v-html="cpaQuestionHtml"></div>
            <div class="sdm-cpa-options">
              <div v-for="(opt, oIdx) in cpaCurrentOptions" :key="oIdx" class="sdm-cpa-option">
                <div class="sdm-cpa-option-letter" :class="'letter-' + oIdx">
                  {{ String.fromCharCode(65 + oIdx) }}
                </div>
                <div class="sdm-cpa-option-text">{{ opt.val || opt.data || opt.text || opt }}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="sdm-image-container">
            <img v-if="curQuestion && curQuestion.pic" :src="curQuestion.pic.startsWith('http') ? curQuestion.pic : Fn.hashToUrl(curQuestion.pic)" alt="Slide Image" class="sdm-slide-image" />
            <div v-else-if="curQuestion && (curQuestion.abstractData || (curQuestion.abstract && curQuestion.abstract.data))" class="sdm-cpa-question" style="padding: 16px; width: 100%; max-height: 150px; overflow-y: auto;" v-html="curQuestion.abstractData || curQuestion.abstract.data"></div>
            <div v-else class="sdm-no-image">No Image Available</div>
          </div>
        </template>
      </div>

      <div class="sdm-info-box">
        <div class="sdm-info-icon"><i class="el-icon-info"></i></div>
        <div class="sdm-info-text" v-html="infoHtml"></div>
      </div>

      <div class="sdm-redo-checkbox" v-if="isRedoDemo">
        <el-checkbox v-model="replaceRecordingLocal">
          Record demo again and replace the original recording
        </el-checkbox>
      </div>
      </template>

      <div v-if="isCountingDown" style="text-align: center; margin: 40px 0;">
        <div style="font-size: 48px; font-weight: bold; color: #10b981;">{{ countdown }}</div>
        <div style="font-size: 16px; color: #64748b; margin-top: 16px;">Video recording is going to be started</div>
      </div>
      <button v-else class="sdm-start-btn" @click="startDemoClick" :disabled="isLoading">
        <i v-if="isLoading" class="el-icon-loading"></i> {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StartDemoPopup',
  props: {
    type: {
      type: String,
      enum: ['live-log', 'group-log', 'parellel-log', 'analyticsDemo'],
      required: true
    },
    cpaStat: {
      type: Object,
      default: null
    },
    curQuestion: {
      type: Object,
      required: true
    },
    isRedoDemo: {
      type: Boolean,
      default: false
    },
    replaceRecording: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    studentName: {
      type: String,
      default: 'Student name'
    }
  },
  data() {
    return {
      countdown: 3,
      isCountingDown: false,
      countdownTimer: null,
      replaceRecordingLocal: this.replaceRecording
    }
  },
  computed: {
    Fn() {
      return window.Fn || {}
    },
    cpaQuestionHtml() {
      if (!this.curQuestion) return ''
      return this.curQuestion.abstractData || this.curQuestion.data || (this.curQuestion.abstract && this.curQuestion.abstract.data) || 'Question Data'
    },
    cpaCurrentOptions() {
      if (!this.curQuestion) return []
      return this.curQuestion.options || []
    },
    titleText() {
      if (this.type === 'live-log') return 'Live Demo'
      if (this.type === 'group-log') return 'Group Demo'
      if (this.type === 'parellel-log') return 'Parallel Feedback'
      if (this.type === 'analyticsDemo') return 'Show Demo'
      return 'Live Demo' // default
    },
    subtitleText() {
      if (this.type === 'parellel-log') return 'Provide an explanation for the following question.'
      if (this.type === 'group-log') return 'Start a Group demo session for the following question.'
      if (this.type === 'analyticsDemo') return 'Start a demo session for the following question.'
      return 'Start a Live demo session for the following question.'
    },
    buttonText() {
      if (this.type === 'parellel-log') return 'Start'
      return 'Start Demo'
    },
    infoHtml() {
      if (this.type === 'live-log') {
        return `As soon as you start demo, we will record the demo session and the <strong>"${this.studentName}"</strong> will join you in the main room to get a live explanation`
      }
      if (this.type === 'group-log') {
        return 'As soon as you start demo, we will record the demo session and <strong>all students stuck or with wrong answers</strong> for this question will join you in the main room to get a live explanation'
      }
      if (this.type === 'parellel-log') {
        return 'Click start to view the student’s draft while we record your explanation. The student won’t join you in the main room.'
      }
      if (this.type === 'analyticsDemo') {
        return 'As soon as you start demo, the entire class will join you in the main room to get a live explanation'
      }
      return 'As soon as you start demo, we will record the demo session and the entire class will join you in the main room to get a live explanation.'
    }
  },
  watch: {
    replaceRecordingLocal(val) {
      this.$emit('update:replaceRecording', val)
    }
  },
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer)
  },
  methods: {
    close() {
      if (this.isCountingDown) return // Prevent closing while counting down
      this.$emit('close')
    },
    startDemoClick() {
      if (this.type === 'parellel-log') {
        this.$emit('start')
        return
      }
      this.isCountingDown = true
      let count = 3
      this.countdown = count
      this.countdownTimer = setInterval(() => {
        this.countdown--
        if (this.countdown === 0) {
          clearInterval(this.countdownTimer)
          this.isCountingDown = false
          this.$emit('start')
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
/* Inherited from DemoSessionPage.vue */
.sdm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000010;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.6);
}
.sdm-modal {
  background: white;
  border-radius: 16px;
  width: 500px;
  max-width: 90vw;
  padding: 24px 32px;
  box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04);
}
.sdm-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.sdm-title {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #1e293b;
}
.sdm-close {
  font-size: 20px;
  color: #64748b;
  cursor: pointer;
  transition: color 0.2s;
}
.sdm-close:hover {
  color: #0f172a;
}
.sdm-subtitle {
  margin: 0 0 24px 0;
  font-size: 14px;
  color: #64748b;
}
.sdm-preview-area {
  margin-bottom: 24px;
  max-height: 300px;
  overflow-y: auto;
}
.sdm-bloom-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
}
.sdm-bloom-level {
  margin: 0;
  font-size: 14px;
  font-weight: bold;
  color: #1e293b;
}
.sdm-bloom-stats {
  display: flex;
  gap: 12px;
  font-size: 12px;
  font-weight: bold;
}
.sdm-stat-attempted { color: #64748b; }
.sdm-stat-stuck { color: #eab308; }
.sdm-stat-wrong { color: #ef4444; }

.sdm-cpa-box {
  background: #f8fafc;
  border-radius: 8px;
  padding: 16px;
}
.sdm-cpa-question {
  font-size: 13px;
  color: #334155;
  font-weight: 600;
  margin-bottom: 16px;
}
.sdm-cpa-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.sdm-cpa-option {
  display: flex;
  align-items: center;
  gap: 12px;
}
.sdm-cpa-option-letter {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 12px;
  font-weight: bold;
  flex-shrink: 0;
}
.letter-0 { background: #8b5cf6; }
.letter-1 { background: #ec4899; }
.letter-2 { background: #3b82f6; }
.letter-3 { background: #f97316; }
.letter-4 { background: #10b981; }
.letter-5 { background: #eab308; }

.sdm-cpa-option-text {
  font-size: 14px;
  color: #334155;
  font-weight: 500;
}
.sdm-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.sdm-slide-image {
  max-width: 100%;
  max-height: 120px;
  border-radius: 8px;
}
.sdm-no-image {
  padding: 40px;
  color: #94a3b8;
  font-weight: bold;
}
.sdm-info-box {
  display: flex;
  gap: 12px;
  padding: 12px 0;
  margin-bottom: 24px;
}
.sdm-info-icon {
  color: #3b82f6;
  font-size: 18px;
  margin-top: 2px;
}
.sdm-info-text {
  font-size: 13px;
  color: #64748b;
  line-height: 1.4;
}
.sdm-redo-checkbox {
  margin-bottom: 24px;
}
.sdm-start-btn {
  width: 100%;
  padding: 14px;
  background: #6366f1;
  color: white;
  border: none;
  border-radius: 24px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: opacity 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.sdm-start-btn:hover {
  opacity: 0.9;
}
.sdm-start-btn:disabled {
  background: #94a3b8;
  cursor: not-allowed;
}
</style>
